<template>
  <div
    ref="navigationContainer"
    class="navigation"
    v-on:mouseleave="mouseleave"
  >
    <utility></utility>

    <!-- xs sm md -->
    <div class="wrapper-sm-md d-block d-lg-none">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-4">
            <hamburger></hamburger>
          </div>
          <div class="col-4">
            <a v-bind:href="logoUrl" class="resmed-brand" target="_self"></a>
          </div>
          <div class="col-4 d-flex flex-row-reverse justify-content-around">
            <a
              href="javascript:void(0);"
              @click.prevent="toggleSearch()"
              class="btn icon"
              :class="{
                search: !mobileSearchActive,
                'search-active': mobileSearchActive,
              }"
              v-if="showSearch"
            ></a>
            <div class="dropdown-menu">
              <!-- <a @click="menuClicked = !menuClicked" class="profile-photo"> </a> -->
              <a
                v-on:click="
                  username !== null
                    ? (menuClicked = !menuClicked)
                    : redirectNotLoggedInUser()
                "
                class="profile-photo"
                v-if="usericon == '0'"
                style="filter: invert(100%);"
              >
              </a>
              <a
                v-on:click="
                  username !== null
                    ? (menuClicked = !menuClicked)
                    : redirectNotLoggedInUser()
                "
                class="profile-photo-login"
                v-else
              >
              </a>
              <ul
                v-if="menuClicked && username !== null"
                @click="menuClicked = !menuClicked"
              >
                <li class="px-3">
                  {{ $getTranslation("Welcome", $route.params.region) }},
                  {{ username }}
                </li>
                <li class="px-3">
                  <a :href="viewProfile" target="_blank">{{
                    $getTranslation("View Profile", $route.params.region)
                  }}</a>
                </li>
                <li class="px-3">
                  <a
                    href="#"
                    target="_blank"
                    v-on:click.prevent="checkSession"
                    >{{ $getTranslation("Logout", $route.params.region) }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <items-sm-md
      @on-search-active-changed="mobileSearchActive = $event"
    ></items-sm-md>

    <!-- lg xl -->
    <div
      class="wrapper-lg-xl d-none d-lg-block"
      v-bind:class="{
        'default--white': !reversed,
        'reversed--color': reversed,
        'is-sticky transition-in': sticky.active,
        'transition-allowed': sticky.allowed,
        'transition-out':
          (sticky.direction === 'up' && !sticky.allowed) ||
          sticky.direction === 'down',
      }"
    >
      <items-lg-xl v-bind:items="items" v-bind:promos="promos"></items-lg-xl>
    </div>
  </div>
</template>

<script>
import utility from "./utility";
import hamburger from "./hamburger";
import itemsLgXl from "./header-items-lg-xl.vue"; // lg xl
import itemsSmMd from "./header-items-sm-md.vue"; // xs sm md
import debounce from "lodash/debounce";
import headerProductReview from "./header-product-review.vue"; // xs sm md

export default {
  name: "navigation",
  components: {
    utility,
    hamburger,
    itemsLgXl,
    itemsSmMd,
    headerProductReview,
  },
  data() {
    return {
      searchFocused: false,
      mobileSearchActive: false,
      desktopSearchActive: true,
      // search: "text-icon", // xhr get request on create method
      reversed: false,
      sticky: {
        active: false,
        allowed: false,
        direction: "",
        i: 0,
      },
      promos: [],
      items: [],
      stickyTimeout: null,
      viewProfile: `${process.env.VUE_APP_ROCUI_ENDPOINT}/${
        this.$route.params.region
      }/dashboard`,
      siteUrl: localStorage.getItem("siteUrl"),
      logoUrl: "https://www.resmed.com",
      username: "",
      showSearch: true,
      menuClicked: false,
      usericon: "",
      siteRegion: "",
    };
  },
  methods: {
    toggleSearch() {
      bus.$emit("hamburger:mobile-search", !this.mobileSearchActive);
      bus.$emit("hamburger:active", false);
    },
    mouseleave() {
      if (!this.searchFocused) {
        bus.$emit("navigation:mouseleave", true);
      }
    },
    debounce: debounce(function() {
      this.sticky.allowed = (window.pageYOffset || window.scrollY) > 200; // threshold

      this.sticky.direction =
        document.body.getBoundingClientRect().top > this.sticky.i
          ? "up"
          : "down";
      this.sticky.i = document.body.getBoundingClientRect().top;

      if (this.sticky.allowed && this.sticky.direction === "up") {
        this.sticky.active = true;
      } else {
        if (this.sticky.allowed) {
          // transition allowed
          clearTimeout(this.stickyTimeout);

          // delay: keep active `true` until transition-out has finished
          this.stickyTimeout = setTimeout(() => {
            this.sticky.active = false;
          }); // 100ms shy of animation
        } else {
          // no transition
          this.sticky.active = false;
        }
      }
    }),
    checkSession() {
      console.log("log");
      axios
        .get("https://resmed-ext-1.okta.com/api/v1/sessions/me", {
          headers: {
            "Content-Type": "application/json"
          },
          withCredentials: true,
        })
        .then((response) => {
          console.log(response,"response")
           console.log("log11");
          if (response.data.id) {
            this.logout(response.data.id);
             console.log("log11");
          } else {
            //If Id is not present in the response, clear cookies
console.log("log1221");
            this.clearCookies();
          }
        })
        .catch((error) => {
          console.log("error", error);
          // If API returns error, clear cookies

          this.clearCookies();
        });
    },
    logout(sessionId) {
       console.log("log123");
      axios
        .delete("https://b2baccounts.resmed.com/resmed-sso/v1/user/logout", {
          headers: {
            okta_sid: sessionId,
          },
        })
        .then((response) => {
          this.clearCookies();
        })
        .catch((error) => {
          // If API returns error, clear cookies
          console.log("Something went wrong", error);
        });
    },
    clearCookies() {
      const keys = $cookies.keys();
      if (keys.length) {
        keys.forEach((item) => {
          $cookies.remove(
            item,
            null,
            window.location.hostname === "localhost"
              ? "localhost"
              : "resmed.com"
          );
        });
      }
      // $cookies.remove("b2bFirstName", null, ".resmed.com");
      // $cookies.remove("role", null, ".resmed.com");
      // $cookies.remove("RegionCode", null, ".resmed.com");
      // $cookies.remove("redirectLoggedPath", null, ".resmed.com");
      // $cookies.remove("SoftwareURL", null, ".resmed.com");
      window.location.reload();
      //this.clearCookies();
    },

    redirectNotLoggedInUser() {
      window.open(
        `${
          process.env.VUE_APP_ROCUI_ENDPOINT
        }/${this.$route.params.region.replaceAll(
          "/",
          ""
        )}/signin?product-support&redirect_to=${this.$route.path}`,
        "_blank"
      );
    },

    // check the region
    isUk() {
      this.logoUrl = `/${this.$route.params.region}`;
      this.siteRegion = this.$route.params.region;
    },
  },
  created() {
    let arr = location.pathname.split("/").filter(function(e) {
        return e;
      }),
      site = arr[1];
    this.showSearch = location.href === `${this.siteUrl}/` ? false : true;

    // is valid site, or 404
    // let valid = ["sleep-apnea", "portable-oxygen", "ventilation"].some((e) => {
    //   return e === site;
    // });

    // if (arr.length && valid) {
    //   axios
    //     .get(
    //       `//${location.hostname}/en-us/${site}/wp-json/resmed/v1/navigation/header-promos`
    //     )
    //     .then((response) => {
    //       if (
    //         site === "sleep-apnea" ||
    //         site === "ventilation" ||
    //         site === "portable-oxygen"
    //       ) {
    //         for (let value of response.data) {
    //           let obj = {},
    //             match = [];

    //           obj.name = value.name
    //             .replace(/(.*)(?:\(.*\))|(?:\[.*\])/g, "$1")
    //             .trim();
    //           obj.href = value.href;
    //           obj.target = value.target;

    //           match = value.name.match(/\[(.*)\]/gi); // not sure whay group 1 is not match
    //           obj.cta = match[0].replace(/\[|\]/g, "");

    //           match = value.name.match(/\((.*)\)/gi);
    //           if (match !== null) {
    //             obj.intro = match[0].replace(/\(|\)/g, "");
    //           }

    //           this.promos.push(obj);
    //         }
    //       }
    //     });

    //   axios
    //     .get(
    //       `//${location.hostname}/en-us/${site}/wp-json/resmed/v1/navigation/header-navigation`
    //     )
    //     .then((response) => {
    //       if (
    //         site === "sleep-apnea" ||
    //         site === "ventilation" ||
    //         site === "portable-oxygen"
    //       ) {
    //         response.data.shift();
    //         this.items = response.data;
    //       }
    //     });
    // } else {
    //   // index (consumers)
    //   this.items = [
    //     { name: "Sleep Apnea", href: "/en-us/sleep-apnea/" },
    //     { name: "Portable Oxygen", href: "/en-us/portable-oxygen/" },
    //     { name: "Ventilation", href: "/en-us/ventilation/" },
    //     {
    //       name: "I’m a Healthcare Professional",
    //       href:
    //         "https://www.resmed.com/us/en/healthcare-professional.html?utm_source=rmd&utm_medium=b2c-website",
    //     },
    //   ];
    // }

    // sticky nav
    // window.addEventListener("scroll", () => {
    //   this.debounce();
    // });

    // get_field `nav-search-icon`
    // axios
    //   .get(
    //     `//${location.hostname}/en-us/wp-json/resmed/v1/get-field/nav-search-icon/87`
    //   )
    //   .then((response) => {
    //     this.search = response.data;
    //   });

    bus.$on("navigation:reversed", (arg) => {
      this.reversed = arg;
    });

    bus.$on("site-search-focused", () => {
      this.searchFocused = true;
    });
    bus.$on("site-search-blurred", () => {
      this.searchFocused = false;
    });

    $(document).on("click", (e) => {
      if (
        this.desktopSearchActive &&
        !$(e.target).closest($(this.$refs.navigationContainer)).length
      ) {
        bus.$emit("navigation:desktop-click-outside", true);
      }
    });
  },
  mounted() {
    this.username = $cookies.get("b2bFirstName");
    if (this.username === null) {
      //  this.tooltipContent = "Login Here";
      this.usericon = "0";
      //  console.log(this.usericon);
    } else {
      //  this.tooltipContent = "View Profile";
      this.usericon = "1";
      //  console.log(this.usericon);
    }

    this.isUk();
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.navigation {
  position: relative;
  z-index: 101;

  .wrapper-sm-md {
    width: 100%;

    position: fixed; // can’t use sticky here
    top: 0;
    z-index: 99;

    padding: 0.5rem 0;
    background-color: $darkgrey;

    @media (min-width: 576px) {
      padding: 1.5rem 0;
    }
  }

  .wrapper-lg-xl {
    width: 100%;
    position: absolute;
  }

  .container {
    @media (max-width: 575px) {
      padding: 0 2rem;
    }
  }

  .search {
    @media (max-width: 991px) {
      margin-top: 2px;
      float: right;

      background-image: url(#{$assets}/images/icon-search-white.svg);
      background-size: 1.33rem 1.25rem;

      width: 1.25rem;
      height: 1.25rem;
    }
  }

  .search-active {
    @media (max-width: 991px) {
      float: right;

      background-image: url(#{$assets}/images/icon-close-gray.svg);
      background-size: 1.33rem 1.25rem;

      width: 1.25rem;
      height: 1.25rem;
    }
  }

  .is-sticky {
    position: fixed;
    top: 0;
    left: 0;
    background-color: $cc-resmed-white;

    // transition only when allowed
    // below threshold
    &.transition-allowed {
      &.transition-in {
        animation: sticky-transition-in 0.5s;
        animation-fill-mode: forwards;
      }

      &.transition-out {
        animation: sticky-transition-out 700ms ease;
        // animation-direction: reverse;
      }
    }
  }

  .resmed-brand {
    display: block;
    height: 38px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    background-image: url(#{$assets}/images/logo-white.png);
    margin: 0 auto;

    @media (min-width: 576px) {
      width: 66px;
      height: 48px;
    }
  }

  @keyframes sticky-transition-in {
    0% {
      transform: translateY(-160px);
      opacity: 0.25;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes sticky-transition-out {
    0% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(-160px);
      opacity: 0;
    }
  }
}

.profile-photo {
  display: block;
  height: 25px;
  width: 25px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  background-image: url("#{$assets}/images/userlogin.png");
  filter: invert(100%);
}
.profile-photo-login {
  display: block;
  height: 25px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  background-image: url("#{$assets}/images/user-profile.png");
}

.dropdown-menu a {
  display: block;
  color: #fff;
  text-decoration: none;
  width: 25px;
}

.dropdown-menu ul {
  display: block;
  float: left;
  position: relative;
  background: #222;
  color: #fff;
  margin-right: 0 !important; // }
}

.dropdown-menu ul {
  position: absolute;
  right: 5px;
  margin: 0;
  z-index: 1;
  padding: 0;
  top: 2.5rem;
  list-style: none;
}

.dropdown-menu ul li {
  background: #333;
  min-width: 9rem;
  padding: 10px;
  font-size: 0.875rem;
}

.tooltipQualityAssistant.tooltip {
  z-index: 102;
  background: #363636;
  color: #d1d1d1;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
</style>
